<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Your Team</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <loading-panel v-if="loading"></loading-panel>
      <div v-else>
        <members></members>

        <hr>
    
        <users></users>

        <hr>

        <observable-accounts></observable-accounts>
      </div>
    </b-container>
  </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import Members from "./Members";
import Users from "./Users";
import ObservableAccounts from "./ObservableAccounts";

export default {
  components: {
    RouteBreadCrumb,
    Members,
    Users,
    ObservableAccounts
  },
  data: function() {
    return {
      loading: false,
    }
  },
  mounted() {
    document.title = 'Your Team';
  }
};
</script>